export enum Button {
  ADD_FOLDER = 'ADD_FOLDER',
  CHOOSE_SELECTION = 'CHOOSE_SELECTION',
  DELETE_SELECTION = 'DELETE_SELECTION',
  INVERSE_SELECTION = 'INVERSE_SELECTION',
  REFRESH_FILES_LIST = 'REFRESH_FILES_LIST',
  DOWNLOAD_AS_ZIP = 'DOWNLOAD_AS_ZIP',
  SELECT_ALL = 'SELECT_ALL',
  UNSELECT_ALL = 'UNSELECT_ALL',
  MODE = 'MODE',
}
